var $5b2ac94c380f170c$exports = {};
$5b2ac94c380f170c$exports = {
    "endTime": `Ora de sf\xe2r\u{219}it`,
    "startTime": `Ora de \xeenceput`,
    "time": `Ora`
};


export {$5b2ac94c380f170c$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
